import React, { createContext, useContext, useMemo, useState } from "react";

const CurrencyContext = createContext(null);

// Base currency: PEN (soles)
const rates = {
  PEN: 1,
  USD: 0.27,
  MXN: 4.6,
};

const symbols = {
  PEN: "S/ ",
  USD: "US$ ",
  MXN: "MX$ ",
};

const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("PEN");

  const value = useMemo(() => {
    const formatPrice = (penAmount) => {
      const amount = penAmount * rates[currency];
      const decimals = currency === "PEN" ? 0 : 2;
      return `${symbols[currency]}${amount.toFixed(decimals)}`;
    };

    return {
      currency,
      setCurrency,
      formatPrice,
      rates,
    };
  }, [currency]);

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error("useCurrency must be used within CurrencyProvider");
  }
  return context;
};

export { CurrencyProvider, useCurrency };
